<template>
  <v-dialog
    max-width="900px"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="mb-0">
      <v-toolbar dark color="primary" class="mb-2">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Disponibilidad Semanal</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row class="mb-2">
            <h3 class="mt-2">Jugador: {{ nombrePaciente }}</h3>
          </v-row>

          <v-expansion-panels multiple v-model="panelesAbiertos">
            <v-expansion-panel v-for="dia in dias" :key="dia.idDia">
              <v-expansion-panel-header>
                {{ dia.nombre }}
                <template v-slot:actions>
                  <span class="mr-2 text-caption">
                    {{ (franjasPorDia[dia.idDia] || []).length }} franja(s)
                  </span>
                  <v-icon>$expand</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row
                  v-for="(franja, index) in franjasPorDia[dia.idDia]"
                  :key="index"
                  align="center"
                  no-gutters
                  class="mb-2"
                >
                  <v-col cols="5" sm="4">
                    <v-text-field
                      type="time"
                      label="Desde"
                      hide-details
                      dense
                      v-model="franja.desde"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" sm="4" class="pl-2">
                    <v-text-field
                      type="time"
                      label="Hasta"
                      hide-details
                      dense
                      v-model="franja.hasta"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pl-2">
                    <v-btn
                      icon
                      color="error"
                      @click="eliminarFranja(dia.idDia, index)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-btn
                  small
                  text
                  color="primary"
                  :disabled="(franjasPorDia[dia.idDia] || []).length >= 10"
                  @click="agregarFranja(dia.idDia)"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Agregar franja
                </v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false"
          >Cancelar</v-btn
        >
        <v-btn color="warning" @click.stop="guardar()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import {
  hhmmAMinutos,
  minutosAHhmm,
  esRangoValido,
  seSolapan,
} from "@/utils/disponibilidad";

export default {
  name: "DisponibilidadJugador",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    idPaciente: {
      type: Number,
    },
    nombrePaciente: {
      type: String,
    },
  },
  data() {
    return {
      // Franjas de UI: { idDisponibilidad, desde: "HH:mm", hasta: "HH:mm" }
      franjasPorDia: {},
      panelesAbiertos: [],
      dias: [
        { idDia: 1, nombre: "Lunes" },
        { idDia: 2, nombre: "Martes" },
        { idDia: 3, nombre: "Miércoles" },
        { idDia: 4, nombre: "Jueves" },
        { idDia: 5, nombre: "Viernes" },
        { idDia: 6, nombre: "Sábado" },
        { idDia: 7, nombre: "Domingo" },
      ],
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarDisponibilidad();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          const activo = document.getElementsByClassName("v-dialog--active")[0];
          if (activo) {
            activo.scrollTop = 0;
          }
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarModels() {
      this.franjasPorDia = {};
      this.panelesAbiertos = [];
    },
    inicializarDias() {
      const base = {};
      this.dias.forEach((dia) => {
        base[dia.idDia] = [];
      });
      this.franjasPorDia = base;
    },
    async buscarDisponibilidad() {
      this.inicializarDias();
      if (!this.idPaciente) {
        return;
      }
      try {
        const { data: franjas } = await axios.get("/Disponibilidad/Buscar", {
          params: {
            idJugador: this.idPaciente,
          },
        });
        const agrupadas = {};
        this.dias.forEach((dia) => {
          agrupadas[dia.idDia] = [];
        });
        (franjas || []).forEach((f) => {
          if (!agrupadas[f.idDia]) {
            agrupadas[f.idDia] = [];
          }
          agrupadas[f.idDia].push({
            idDisponibilidad: f.idDisponibilidad,
            desde: minutosAHhmm(f.horaDesde),
            hasta: minutosAHhmm(f.horaHasta),
          });
        });
        this.franjasPorDia = agrupadas;
      } catch (error) {
        void error;
        this.showAlert({
          icon: "error",
          title: "No se pudo cargar la disponibilidad del jugador.",
          vm: this,
          timer: 2000,
        });
      }
    },
    agregarFranja(idDia) {
      const franjas = this.franjasPorDia[idDia] || [];
      if (franjas.length >= 10) {
        return;
      }
      franjas.push({ idDisponibilidad: 0, desde: "", hasta: "" });
      this.$set(this.franjasPorDia, idDia, franjas);
    },
    eliminarFranja(idDia, index) {
      const franjas = this.franjasPorDia[idDia] || [];
      franjas.splice(index, 1);
      this.$set(this.franjasPorDia, idDia, franjas);
    },
    // Valida todas las franjas: formato, rango (Hasta > Desde) y solapamiento
    // por día. Devuelve el payload de franjas en minutos o null si hay error
    // (mostrando la alerta correspondiente).
    validarYConstruirPayload() {
      const payload = [];
      for (const dia of this.dias) {
        const franjas = this.franjasPorDia[dia.idDia] || [];
        const convertidas = [];
        for (const franja of franjas) {
          const desde = hhmmAMinutos(franja.desde);
          const hasta = hhmmAMinutos(franja.hasta);
          if (Number.isNaN(desde) || Number.isNaN(hasta)) {
            this.showAlert({
              icon: "error",
              title: `Complete correctamente las franjas de ${dia.nombre}.`,
              vm: this,
              timer: 2500,
            });
            return null;
          }
          if (!esRangoValido(desde, hasta)) {
            this.showAlert({
              icon: "error",
              title: `En ${dia.nombre}, la hora Hasta debe ser posterior a la hora Desde.`,
              vm: this,
              timer: 2500,
            });
            return null;
          }
          const solapa = convertidas.some((c) =>
            seSolapan(desde, hasta, c.horaDesde, c.horaHasta),
          );
          if (solapa) {
            this.showAlert({
              icon: "error",
              title: `Existe un solapamiento de franjas en ${dia.nombre}.`,
              vm: this,
              timer: 2500,
            });
            return null;
          }
          convertidas.push({
            idDia: dia.idDia,
            horaDesde: desde,
            horaHasta: hasta,
          });
        }
        payload.push(...convertidas);
      }
      return payload;
    },
    guardar() {
      const self = this;
      const franjas = this.validarYConstruirPayload();
      if (franjas === null) {
        return;
      }
      const body = {
        idJugador: this.idPaciente,
        franjas: franjas,
      };
      axios
        .post("/Disponibilidad/Guardar", body)
        .then((response) => {
          if (response.data === "error") {
            self.showAlert({
              icon: "error",
              title:
                "La disponibilidad no pudo ser guardada. Intente nuevamente más tarde.",
              vm: self,
              timer: 2500,
            });
            return;
          }
          self.showAlert({
            icon: "success",
            title: "Disponibilidad guardada exitosamente",
            vm: self,
            timer: 2000,
          });
          self.$emit("close");
        })
        .catch((error) => {
          const mensaje =
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data)) ||
            "La disponibilidad no pudo ser guardada. Intente nuevamente más tarde.";
          self.showAlert({
            icon: "error",
            title:
              typeof mensaje === "string"
                ? mensaje
                : "La disponibilidad no pudo ser guardada. Intente nuevamente más tarde.",
            vm: self,
            timer: 2500,
          });
        });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
